var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"border":"none","min-height":"1038px"},attrs:{"src":_vm.url,"id":"myiframe","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }